module.exports = __webpack_public_path__ + "static/img/banner1.3a764521.jpg";